export const STANDINGS_PREVIEW_WIDGET = {
  ACTION_TYPES: {
    onCompetitionChange: 'onCompetitionChange',
    competitionsFetch: 'competitionsFetch',
    competitorFetch: 'competitorFetch',
    displayHandler: 'displayHandler'
  },

  ROWS: {
    offsetFromCurrentPosition: 3,
    maxStandingsRows: 7,
    maxGroupStandingRows: 4
  },

  ANALYTICS: {
    STANDINGS_TYPE: {
      normal: 'normal',
      groups: 'groups',
      bracket: 'bracket'
    }
  },

  MAX_LIVE_COMPETITIONS: 5,
}
